export const V_TABS = [
    { title: 'Activity Highlights', key: 'additionalInfo', id: 'additional-info' },
    { title: 'Tour Options', key: 'productOptions', id: 'tour-options' },
    { title: "What's Included", key: 'inclusions', id: 'inclusions' },
    { title: "What's Not Included", key: 'exclusions', id: 'exclusions' },
    { title: 'Itinerary', key: 'itinerary', id: 'itinerary' },
    { title: 'Cancellation Policy', key: 'cancellationPolicy', id: 'cancellation' },
];
